<template>
  <div>
    <div class="page-title">New Countdown Clock</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add Countdown Clock"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.countdowns.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Countdown",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Countdown.new();
      this.form = data;
    },
    async create() {
      await this.$api.Countdown.create(this.form);
      this.$router.push("/widgets/countdowns");
    },
  },
};
</script>

<style></style>
